import {
  createGenerateClassName,
  StylesProvider,
} from "@material-ui/core/styles";
import "materialize-css/dist/css/materialize.min.css";
import React, { useEffect, useState } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import "./assets/scss/button.scss";
import "./assets/scss/style.scss";
import Footer from "./components/footer/TemplateFooter";
import Header from "./components/navigation/Header";
import AllPages from "./components/pages/AllPages";
import Dashboard from "./components/pages/Dashboard";
import EstimateFor from "./components/reusable-components/EstimateFor";
import SettingsTable from "./components/reusable-components/SettingsTable";
import routes from "./components/routes";
import routeslogFn from "./components/routes-log";
import fire from "./config/firebase";
import Estimates from "./components/pages/Estimates";
import Template from "./components/pages/Template";

const generateClassName = createGenerateClassName({
  productionPrefix: "c",
});

function App(props) {

  const [changeRecord, setChangeRecord] = useState({});
  const { location: { pathname } } = props;
  useEffect(() => {
    // setChangeRecord({});
  }, [pathname]);
  // constructor(props) {
  //   super(props);
  //   this.authListner = this.authListner.bind(this);
  //   this.state = {
  //     user: undefined,
  //     update: 1,
  //   };
  //   update = update.bind(this);
  // }
  const [user, setUser] = useState(undefined);
  const [update, setUpdate] = useState(1)

  const authListner = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });
  }
  useEffect(() => {
    authListner();
  }, []);

  const incrementUpdate = () => {
    setUpdate(update + 1);
  };

  const routeslog = routeslogFn({
    updateCnt: update,
    updateFn: incrementUpdate,
    setChangeRecord,
    changeRecord
  });

  return (
    <React.Fragment key={props.location.pathname}>
      <StylesProvider generateClassName={generateClassName}>
        {user ? (
          <Switch>
            <Route path="/estimates" exact={true}>
              <React.Fragment>
                <Header
                  updateCnt={update}
                  update={incrementUpdate}
                />
                <Estimates update={incrementUpdate} />
              </React.Fragment>
            </Route>
            <Route path="/templates" exact={true} key="1t">
              <React.Fragment>
                <Header updateCnt={update} update={incrementUpdate} />
                <Template update={incrementUpdate} />
              </React.Fragment>
            </Route>

            <Route path="/all-pages" exact={true}>
              <React.Fragment>
                <Header updateCnt={update} update={incrementUpdate} />
                <AllPages
                  update={incrementUpdate}
                  updateCnt={update}
                />
              </React.Fragment>
            </Route>

            <Route path="/" exact={true}>
              <React.Fragment>
                <Header updateCnt={update} />
                <Dashboard update={incrementUpdate} />
              </React.Fragment>
            </Route>
            <Route path="/dashboard" exact={true}>
              <React.Fragment>
                <Header updateCnt={update} />
                <Dashboard update={incrementUpdate} />
              </React.Fragment>
            </Route>
            <Route path="/estimates/:projectName/:key">
              <React.Fragment>
                <Header updateCnt={update} />
                <section
                  className="estimated-list"
                  style={{ minHeight: "calc(100vh - 60px)" }}
                >
                  <EstimateFor
                    update={update}
                    updateFn={incrementUpdate}
                    title={"Task Based"}
                    estimateType={"estimates"}
                    type={true}
                    key={props.location.pathname}
                  />
                  <SettingsTable
                    updateCnt={update}
                    update={incrementUpdate}
                    estimateType={"estimates"}
                  />
                </section>
              </React.Fragment>
            </Route>
            <Route path="/templates/:projectName/:key" key="2">
              <React.Fragment>
                <Header />
                <section
                  className="estimated-list"
                  style={{ minHeight: "calc(100vh - 60px)" }}
                >
                  <EstimateFor
                    update={update}
                    updateFn={incrementUpdate}
                    title={"Task Based"}
                    estimateType={"templates"}
                    key={props.location.pathname}
                    type={true}
                  />
                  <SettingsTable
                    updateCnt={update}
                    update={incrementUpdate}
                    estimateType={"templates"}
                  />
                </section>
              </React.Fragment>
            </Route>

            <Route path="/estimates-timebased/:projectName/:key" key="3">
              <React.Fragment>
                <Header />
                <section
                  className="estimated-list"
                  style={{ minHeight: "calc(100vh - 60px)" }}
                >
                  <EstimateFor
                    update={update}
                    updateFn={incrementUpdate}
                    key={props.location.pathname}
                    title={"Time Based"}
                    estimateType={"estimates-timebased"}
                    type={true}
                  />
                  <SettingsTable
                    updateCnt={update}
                    update={incrementUpdate}
                    estimateType={"estimates-timebased"}
                  />
                </section>
              </React.Fragment>
            </Route>
            <Route path="/templates-timebased/:projectName/:key" key="4">
              <React.Fragment>
                <Header />
                <section
                  className="estimated-list"
                  style={{ minHeight: "calc(100vh - 60px)" }}
                >
                  <EstimateFor
                    update={update}
                    updateFn={incrementUpdate}
                    title={"Time Based"}
                    key={props.location.pathname}
                    estimateType={"templates-timebased"}
                    type={true}
                  />
                  <SettingsTable
                    updateCnt={update}
                    update={incrementUpdate}
                    estimateType={"templates-timebased"}
                  />
                </section>
              </React.Fragment>
            </Route>
            {routeslog.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                {route.component}
              </Route>
            ))}
          </Switch>
        ) : (
          user === null && (
            <Switch key="2">
              {routes.map((route) => (
                <Route key={route.path} {...route} />
              ))}
            </Switch>
          )
        )}
        <Footer />
      </StylesProvider>
    </React.Fragment>
  );
}

export default withRouter(App);
